import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
    name: "TeacherTypeDetail",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            noDataMsg: CONFIG.NO_DATA_EXIST,
            isLoading: false,
            type_name: '',
            enable_qr: '',
            teacherTypeData: {}
        };
    },

    methods: {
        getTeacherTypeById() {
            axios.get('teacherType/detail/' + this.$route.params.id)
                .then((response) => {
                    if (response.data != undefined) {
                        this.teacherTypeData = response.data;
                        this.teacherTypeData.enable_qr = this.teacherTypeData.enable_qr == CONFIG.ENABLE_QR.ENABLE ? 'enabled' : 'disabled';
                        if (this.teacherTypeData?.id == null) {
                            // if no data found, print no data message
                            this.teacherTypeData = {};
                        }
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                  this.isLoading = false;
                });
        },
        showList() {
            this.$router.push({
                path: "/teacherType/list"
            });
        },
    },
    mounted() {
        this.isLoading = true;
        this.getTeacherTypeById();
    },
};
